/*eslint-disable*/
import React, { useState, useEffect, useImperativeHandle } from "react";
import {
  TextField,
  Typography,
  Divider,
  Paper,
  Grid,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import CustomDropDownPicker from "../../../components/CustomDropDownPicker";
import PropertyTypeDropdown from '../../../components/PropertyTypeDropdown';
import { STYLES } from "config";

function ListingInformationComponent(props) {
  const { data, setvalue } = props;
  const [state, setstate] = useState(data);

  useEffect(() => {
    setstate(data);
  }, [data]);

  const locationOptions = [
    { value: "address", label: "Address" },
    { value: "suburb", label: "Suburb" },
  ];

  const updateData = (e) => {
    const updatedState = { ...state, [e.target.name]: e.target.value };
    setstate(updatedState);
    setvalue(updatedState);
  };

  const updateDataNested = (e) => {
    const { name, value } = e.target;
    const keys = name.split(".");
    const updatedState = { ...state };

    let current = updatedState;
    for (let i = 0; i < keys.length - 1; i++) {
      current = current[keys[i]] = current[keys[i]] || {};
    }
    current[keys[keys.length - 1]] = value;

    setstate(updatedState);
    setvalue(updatedState);
  };

  const handleDropdownChange = (name, value) => {
    const keys = name.split(".");
    const updatedState = { ...state };

    let current = updatedState;
    for (let i = 0; i < keys.length - 1; i++) {
      current = current[keys[i]] = current[keys[i]] || {};
    }
    current[keys[keys.length - 1]] = value;

    setstate(updatedState);
    setvalue(updatedState);
  };

  // Dropdown options for property type
  const propertyTypeOptions = [
    { label: "", value: "" },
    { label: "House", value: 4 },
    { label: "Apartment / Flat", value: 5 },
    { label: "Townhouse", value: 6 },
    { label: "Vacant Land / Plot", value: 8 },
    { label: "Farm", value: 10 },
    { label: "Retail", value: 11 },
    { label: "Commercial Property", value: 11 },
    { label: "Industrial Property", value: 12 }
  ];

  useImperativeHandle(props.ref, () => ({
    isValidated() {
      const typeOfProperty = state?.typeOfProperty;
      const p24propertyType = state?.p24propertyType;
      const pppropertyType = state?.ppValue;
      const address = state?.address?.description;
      const streetNumber = state?.address?.streetNumber;
      const streetName = state?.address?.streetName;
      let isValid = true;

      const newErrors = {};

      if (!typeOfProperty || typeOfProperty === "") {
        newErrors.status = "Property type is required";
        isValid = false;
      }

      if (!p24propertyType || p24propertyType === "") {
        newErrors.status = "p24propertyType is required";
        isValid = false;
      }

      if (!pppropertyType || pppropertyType === "") {
        newErrors.status = "pppropertyType is required";
        isValid = false;
      }

      if (!address || address === "") {
        newErrors.address = "address is required";
        isValid = false;
      }

      if (!streetNumber || streetNumber === "") {
        newErrors.streetNumber = "street number is required";
        isValid = false;
      }

      if (!streetName || streetName === "") {
        newErrors.streetName = "street number is required";
        isValid = false;
      }

      setErrors(newErrors);
      return isValid;
    }
  }));

  return (
    <Paper elevation={5} sx={{ p: 3 }}>
      <Box sx={{ p: 2 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 400,
            mb: 1,
            color: STYLES.WEB_APP_FONT_CLR
          }}
        >
          Listing Information
        </Typography>

        <Divider sx={{ borderColor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

        <Paper elevation={0} sx={{ p: 2, mb: 2 }}>
          <Typography variant="body1">
            This is the key listing information that will be displayed on the relevant website(s).
          </Typography>
        </Paper>

        <Divider sx={{ borderColor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

        <Grid container spacing={2}>

          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 400,
                mt: 1.5,
                color: STYLES.WEB_APP_FONT_CLR
              }}
            >
              Property Type<span style={{ color: "red" }}>*</span>:
            </Typography>

          </Grid>


          <Grid item size={10}>
            <div style={{
              width: "100%",
              zIndex: 10
            }}>
              <PropertyTypeDropdown
                value={state.typeOfProperty}
                onChange={(selectedProperty, p24Value, ppValue) => {
                  setstate({
                    ...state,
                    typeOfProperty: selectedProperty,
                    p24propertyType: p24Value,
                    pppropertyType: ppValue
                  });

                  setvalue({
                    ...data,
                    typeOfProperty: selectedProperty,
                    p24propertyType: p24Value,
                    pppropertyType: ppValue
                  });
                }}
              />
            </div>
          </Grid>

          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 400,
                mt: 1.5,
                color: STYLES.WEB_APP_FONT_CLR
              }}
            >
              Latitude/Longitude:
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              disabled
              value={
                data?.address?.coords?.lat + "," + data?.address?.coords?.lng
              }
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#003366"
                  }
                },
                "& .MuiInputBase-input": {
                  color: STYLES.WEB_APP_FONT_CLR
                }
              }}
            />
          </Grid>

          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 400,
                mt: 1.5,
                color: STYLES.WEB_APP_FONT_CLR
              }}
            >
              Address<span style={{ color: "red" }}>*</span>:
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              name="address.description"
              size="small"
              value={data?.address?.description || ""}
              onChange={updateDataNested}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#003366"
                  }
                },
                "& .MuiInputBase-input": {
                  color: STYLES.WEB_APP_FONT_CLR
                }
              }}
              required
            />
          </Grid>

          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 400,
                mt: 1.5,
                color: STYLES.WEB_APP_FONT_CLR
              }}
            >
              Street Number<span style={{ color: "red" }}>*</span>:
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              name="address.streetNumber"
              size="small"
              type="number"
              value={data?.address?.streetNumber || ""}
              onChange={updateDataNested}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#003366"
                  }
                },
                "& .MuiInputBase-input": {
                  color: STYLES.WEB_APP_FONT_CLR
                }
              }}
            />
          </Grid>

          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 400,
                mt: 1.5,
                color: STYLES.WEB_APP_FONT_CLR
              }}
            >
              Street Name<span style={{ color: "red" }}>*</span>:
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              name="address.streetName"
              size="small"
              value={data?.address?.streetName || ""}
              onChange={updateDataNested}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#003366"
                  }
                },
                "& .MuiInputBase-input": {
                  color: STYLES.WEB_APP_FONT_CLR
                }
              }}
            />
          </Grid>

          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 400,
                mt: 1.5,
                color: STYLES.WEB_APP_FONT_CLR
              }}
            >
              Unit Number:
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              name="address.unitNumber"
              size="small"
              value={data?.address?.unitNumber || ""}
              onChange={updateDataNested}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#003366"
                  }
                },
                "& .MuiInputBase-input": {
                  color: STYLES.WEB_APP_FONT_CLR
                }
              }}
            />
          </Grid>

          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 400,
                mt: 1.5,
                color: STYLES.WEB_APP_FONT_CLR
              }}
            >
              Complex Name:
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              name="address.complexName"
              size="small"
              value={data?.address?.complexName || ""}
              onChange={updateDataNested}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#003366"
                  }
                },
                "& .MuiInputBase-input": {
                  color: STYLES.WEB_APP_FONT_CLR
                }
              }}
            />
          </Grid>

          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 400,
                mt: 1.5,
                color: STYLES.WEB_APP_FONT_CLR
              }}
            >
              Floor Number:
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              name="address.floorNumber"
              size="small"
              value={data?.address?.floorNumber || ""}
              onChange={updateDataNested}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#003366"
                  }
                },
                "& .MuiInputBase-input": {
                  color: STYLES.WEB_APP_FONT_CLR
                }
              }}
            />
          </Grid>

          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 400,
                mt: 1.5,
                color: STYLES.WEB_APP_FONT_CLR
              }}
            >
              Building Name:
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              name="address.buildingName"
              size="small"
              value={data?.address?.buildingName || ""}
              onChange={updateDataNested}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#003366"
                  }
                },
                "& .MuiInputBase-input": {
                  color: STYLES.WEB_APP_FONT_CLR
                }
              }}
            />
          </Grid>

          {/* <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Property Group:
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            fullWidth
            name="property"
            size="small"
            multiline
            rows={3}
            value={data?.property || ""}
            onChange={updateData}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid> */}

          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 400,
                mt: 1.5,
                color: STYLES.WEB_APP_FONT_CLR
              }}
            >
              WebRef:
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              name="web_Ref_No"
              size="small"
              value={data?.web_Ref_No || ""}
              onChange={updateData}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#003366"
                  }
                },
                "& .MuiInputBase-input": {
                  color: STYLES.WEB_APP_FONT_CLR
                }
              }}
            />
          </Grid>

          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 400,
                mt: 1.5,
                color: STYLES.WEB_APP_FONT_CLR
              }}
            >
              Publish Location As<span style={{ color: "red" }}>*</span>:
            </Typography>

          </Grid>


          <Grid item size={10}>
            <div style={{
              width: "100%",
              zIndex: 10
            }}>
              <CustomDropDownPicker
                borderColor="grey"
                options={locationOptions}
                value={state.locationType}
                onChange={(value) => setstate({
                    ...state,
                    locationType: value
                  })}
                placeholder="Publish Location As"
                required
              />
            </div>
          </Grid>

          {/* <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Virtual Tour:
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            fullWidth
            name="virtualTour"
            size="small"
            value={data?.virtualTour || ""}
            onChange={updateData}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid> */}




          {/* <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Valuation Price:
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            fullWidth
            name="valuationPrice"
            size="small"
            value={data?.valuationPrice || ""}
            onChange={updateData}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid> */}
        </Grid>
      </Box>
    </Paper>
  );
}

export default ListingInformationComponent;
